<div class="modal__header">
	<div class="modal__header-actions header-actions--mobile">
		<button attr.aria-label="{{ 'modals.weakFlightsDiscount.aria.closeDialog' | ibeadmin: 'sync' }}" (click)="INDRA_close()">
			<app-svg svg="icons.svg#general--arrow--left-no_margin" aria-hidden="true" [alt]="'Arrow left icon'"></app-svg>
		</button>
	</div>
	<div class="title_wrapper">
		<h2 class="title" id="modal__title">{{ 'modals.weakFlightsDiscount.title.congratulations' | ibeadmin: 'sync' }}</h2>
	</div>
	<div class="modal__header-actions header-actions">
		<button attr.aria-label="{{ 'modals.weakFlightsDiscount.aria.closeDialog' | ibeadmin: 'sync' }}" (click)="INDRA_close()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>

<div class="modal__body week-flights-body sl--scrollable">
	<div>
		<p class="title-h5 no-margin-top">{{ 'modals.weakFlightsDiscount.text.youHaveBeenChosen' | ibeadmin: 'sync' }}<br>{{ 'modals.weakFlightsDiscount.text.useToSave' | ibeadmin: 'sync' }} {{ amountValue ? amountValue.amount: 0 }} {{ amountValue? amountValue.currency: '' }} {{ 'modals.weakFlightsDiscount.text.inThisBooking' | ibeadmin: 'sync' }}</p>
	</div>

	<div class="banner-image" [ngStyle]="{'background-image':'url( assets/images/destin_geral.jpg )'}" ></div>

	<div>
		<p>{{ 'modals.weakFlightsDiscount.text.dontTellAnyone' | ibeadmin: 'sync' }} {{ amountValue ? amountValue.amount: 0 }} {{ amountValue? amountValue.currency: '' }}</p>
		<p class="description">{{ 'modals.weakFlightsDiscount.text.thePrices' | ibeadmin: 'sync' }}</p>
	</div>
</div>
<div class="modal__footer">
	<div class="modal__footer-action align-right">
		<button class="button button--small" (click)="INDRA_close()">{{ 'modals.weakFlightsDiscount.text.selectFlights' | ibeadmin: 'sync' }}</button>
	</div>
</div>
